import { useEffect } from 'react';

import { CheckmarkCircleIc } from '@dsch/dd-icons';

import { Text } from '../../../../components/ToolkitV2/Text/Text';
import { Link } from '../../../../components/Toolkit/Button/Link';
import { ButtonLink } from '../../../../components/Toolkit/Button/ButtonLink';
import { ListNative } from '../../../../components/ToolkitV2/ListNative/ListNative';

import * as Styled from './ApplicationComplete.styled';

import { Spacer } from '../../../../helpers/genericStyles';
import { theme } from '../../../../helpers/Theme/Theme';
import { scrollToTop } from '../../../../helpers/scroll';

const ApplicationComplete = () => {
  /**
   * On submit, the user will be scrolled to the end of the page.
   *
   * On load of the success display, we therefore scroll the page to the top.
   */
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <Styled.Container>
      <CheckmarkCircleIc
        height="48px"
        width="48px"
        color={theme.colors.GREEN}
      />
      <Spacer marginBottom="M16" />
      <Text
        forwardedAs="h1"
        weight="bold"
        color="GREY_DARKER"
        size="L24"
        responsiveSizes={{ medium: 'H32' }}
      >
        Your application has been submitted!
      </Text>
      <Spacer marginBottom="M16" />
      <Text size="M16">
        Your application will be reviewed shortly. In the meantime, we've sent
        you an email with detailed instructions on the next steps.
      </Text>
      <Spacer marginBottom="M32" />
      <Text forwardedAs="h2" weight="bold" color="GREY_DARKER" size="L18">
        What happens next?
      </Text>
      <Spacer marginBottom="M16" />
      <ListNative
        name="next-steps"
        markerColour="GREY_DARKER"
        markerSize="M16"
        listType="ol"
        markerFontWeight="bold"
      >
        <>
          <Text color="GREY_DARKER" size="M16" weight="bold">
            Contact the dealership
          </Text>
          <Text size="M16">
            The dealership will be updated on the progress of your application.
            We recommend contacting them after one working day when they will
            know if your application is approved or declined.
          </Text>
          <Spacer marginBottom="M16" />
        </>
        <>
          <Text color="GREY_DARKER" size="M16" weight="bold">
            Finalise the finance agreement
          </Text>
          <Text size="M16">
            The dealership will talk you through the finance agreement, answer
            your questions and complete your paperwork.
          </Text>
        </>
      </ListNative>
      <Spacer marginBottom="M16" />
      <Text size="M16" weight="regular">
        If you have any questions, please{' '}
        <Link
          inline
          underline
          href="https://hello.donedeal.ie/hc/en-us/requests/new"
        >
          contact us.
        </Link>
      </Text>
      <Spacer marginBottom="M32" />
      <ButtonLink href="/">Take me to DoneDeal</ButtonLink>
    </Styled.Container>
  );
};

export { ApplicationComplete };
